import React from 'react';
import { KFLTypography, KFLButton, KFLIcon } from '@kamstrup/kamstrup-frontend-library';
import './dialogHeader.scss';

const createCloseButton = (closeFn?: () => void) =>
  closeFn ? (
    <div id="dialog-close" className="close_btn">
      <KFLButton onClick={closeFn} variant="secondary">
        <KFLIcon name="Close" color="#009ca6" />
      </KFLButton>
    </div>
  ) : undefined;

const createBackButton = (backFn?: () => void) =>
  backFn ? (
    <div id="dialog-back" className="back_btn">
      <KFLButton onClick={backFn} variant="secondary">
        <KFLIcon name="Back" color="#009ca6" />
      </KFLButton>
    </div>
  ) : undefined;

const createRefreshButton = (refreshFn?: () => void) =>
  refreshFn ? (
    <div id="dialog-refresh" className="refresh_btn">
      <KFLButton onClick={refreshFn} variant="secondary">
        <KFLIcon name="Reverse" color="#009ca6" />
      </KFLButton>
    </div>
  ) : undefined;

interface OwnProps {
  title: JSX.Element | string;
  fnCloseDialog?: () => void;
  fnBackDialog?: () => void;
  fnRefreshDialog?: () => void;
}

type IProps = OwnProps;

const DialogHeader: React.FC<IProps> = (props) => {
  return (
    <div className="dialog_header">
      <KFLTypography type="heading" size="medium">
        {props.title}
      </KFLTypography>

      <span className="header_btns">
        {createCloseButton(props.fnCloseDialog)}
        <span className="btn_divider">&nbsp;</span>
        {createRefreshButton(props.fnRefreshDialog)}
        {createBackButton(props.fnBackDialog)}
      </span>
    </div>
  );
};

export default DialogHeader;
